<template>
    <div class="font">
        <div class="fontsize fl"  @mouseenter="fontsizefag=1" @mouseleave="fontsizefag=0">
            <span>{{selectsize.content}}</span>
            <ul v-show="fontsizefag">
                <li v-for="(item,index) in fontsize" :key="index" :data-value='item.value' @click="change('selectsize',item)">{{item.content}}</li>
            </ul>
        </div>
        <div class="family fl"  @mouseenter="fontfamilyfag=1" @mouseleave="fontfamilyfag=0">
            <span :style="{'font-family':selectfamily.value}">{{selectfamily.content}}</span>
            <ul v-show="fontfamilyfag">
                <li v-for="(item,index) in fontfamily" :key="index" :data-value='item.value' @click="change('selectfamily',item)">{{item.content}}</li>
            </ul>
        </div>
        <div class="color fl"  @mouseenter="fontcolorfag=1" @mouseleave="fontcolorfag=0" :style="{background:selectbg}">
            <span></span>
            <ul v-show="fontcolorfag">
                <li v-for="(item,index) in fontcolor" :key="index" :data-value='item.value' :style="{background:item.value,height:'20px'}" @click="change('selectbg',item.value)"></li>
            </ul>
        </div>
    </div>
</template>

<script>
// import Bus from '../../store/plugins/bus.js'
export default {
    name: 'font',
    data(){
        return{
            fontsize:[{value:'12px',content:'小'},{value:'18px',content:'中'},{value:'26px',content:'大'}],
            fontfamily:[{value:'Microsoft Yahei',content:'黑体'},{value:'宋体',content:'宋体'},{value:'楷体',content:'楷体'}],
            fontcolor:[{value:'black',content:'黑'},{value:'red',content:'红'},{value:'green',content:'绿'}],
            fontsizefag:0,
            fontfamilyfag:0,
            fontcolorfag:0,
            selectbg:'black',
            selectfamily:{value:'宋体',content:'宋体'},
            selectsize:{value:'12px',content:'小'},
            resultstyle:{'font-size':'12px','font-family':'宋体','color':'black',}
        }
    },
    methods:{
        change(mod,val){
            if(mod == "selectsize"){
                this.selectsize = val;
                this.resultstyle['font-size'] = val.value;
            }else if(mod == "selectfamily"){
                this.selectfamily = val;
                this.resultstyle['font-family'] = val.value;
            }else if(mod == "selectbg"){
                this.selectbg = val;
                this.resultstyle['color'] = val;
            }
            Bus.$emit('changefontstyle', this.resultstyle)
            this.$emit('changestyle', this.resultstyle)
        }
    }
}
</script>

<style>
    .font{
        width: 200px;
        height: 25px;
        padding: 3px 5px;
        position: absolute;
        top: -40px;
        left: 0px;
        text-align: left;
        z-index: 10;
        border: 1px solid #bfd4de;
        background-color: white;
        border-radius: 3px;
    }
    .font:before {
        content: '';
        position: absolute;
        left: 13px;
        top: 32px;
        margin-left: -7px;
        border: 7px solid transparent;
        border-top-color: #bfd4de;
    }
    .font:after {
        left: 13px;
        top: 32px;
        content: '';
        position: absolute;
        margin-left: -7px;
        margin-top: -2px;
        border: 7px solid transparent;
        border-top-color: #fff;
    }
   .font .fontsize, .font .family, .font .color {
        position: relative;
        width: 50px;
        padding-left: 3px;
        cursor: pointer;
        border: 1px solid #bfd4de;
        margin-right: 5px;
        height: 21px;
    }
    
    .font ul{
        position: absolute;
        left: -1px;
        top: 20px;
        list-style: none;
        background-color: white;
        padding: 0;
        border: 1px solid gainsboro;
        border-top-color: transparent;
        z-index: 3;
        zoom: 1;
    }
    .font li {
        cursor: pointer;
        zoom: 1;
        padding-left: 3px;
        display: inline-block;
        width: 50px;
        /* margin-left: -4px; */
    }
    .font li:hover{
        background-color: #c7e6f5;
    }
</style>



// WEBPACK FOOTER //
// src/components/templates/font.vue